<template>
  <v-container fluid grid-list-md>
    <v-toolbar class="mb-4" :class="isDesktop ? 'no-right-padding' : ''">
      <v-toolbar-title>
        Projects
        <v-btn
          icon
          small
          color="info"
          :to="{name: 'projects-edit', params: {project_id: 0} }"
        >
          <v-icon size="18">add</v-icon>
        </v-btn>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-layout v-if="isDesktop">
        <v-spacer></v-spacer>
        <v-flex xs12 sm4>
          <v-text-field
            outline
            autofocus
            clearable
            v-model="filter.search"
            label="Search by title"
            hide-details
          />
        </v-flex>
        <v-flex xs12 sm2>
          <v-select
            v-model="sort"
            outline
            hide-details
            label="Sorting"
            :items="sorts.projects"
            item-text="title"
            item-value="value"
          />
        </v-flex>
      </v-layout>
      <v-menu :close-on-content-click="false" v-else bottom offset-y right>
        <v-btn slot="activator" small icon class='ma-0' color="secondary">
          <v-icon>more_vert</v-icon>
        </v-btn>
        <v-card>
          <v-card-text>
            <v-text-field
              outline
              v-model="filter.search"
              clearable
              label="Search by title"
            />
            <v-select
              v-model="sort"
              outline
              label="Sorting"
              :items="sorts.projects"
              item-text="title"
              item-value="value"
              hide-details
            />
          </v-card-text>
        </v-card>
      </v-menu>
    </v-toolbar>
    <progress-bar></progress-bar>
    <div class="spaces_list">
      <router-link
        :to="{name: 'tasks-list', params: {project_id: item.id} }"
        :key="item.id"
        v-for="item in list.items"
        class="spaces_list__item"
      >
        <div class="d-flex elevation-2">
          <div class="spaces_list__item--head">
            <span
              :to="{name: 'tasks-list', params: {project_id: item.id} }"
            >
              {{ item.short_name }}
            </span>
          </div>
          <div class="d-flex justify-space-between">
            <div class="spaces_list__item--body">
              <p> {{ item.name }}</p>
              <v-btn
                @click.prevent="copyText(item)"
                flat
                round
                small
                style="width:25px; height: 25px"
              >
                <v-icon size="12">content_copy</v-icon>
              </v-btn>
            </div>
            <div v-if="isDesktop" class="spaces_list__item--footer">
              <v-btn
                v-if="hasFeature(item, $features.PROJECT_REPORTS)"
                :to="{name: 'projects-report', params: {project_id: item.id} }"
                color="info"
                small
                block
              >
                Reports
              </v-btn>
              <v-btn
                v-if="canEdit(item)"
                :to="{name: 'projects-edit', params: {project_id: item.id} }"
                color="primary"
                small
                block
              >
                Edit
              </v-btn>
              <remove-dialog :yes="() => remove(item)">
                <v-btn
                  v-if="canDelete(item)"
                  @click.prevent=""
                  style="width:25px; height: 25px"
                  :ripple="false"
                  color="error"
                  round
                  fab
                >
                  <v-icon size="12">delete</v-icon>
                </v-btn>
              </remove-dialog>
            </div>
          </div>
        </div>
      </router-link>
    </div>
    <sl-pagination
      v-if="list.pagination.last_page > 1"
      @changePage="(page) => changePage(page)"
      :count="list.pagination.totalItems"
      :page="list.pagination.current_page"
      :limit="list.pagination.per_page"
      :pagesCount="list.pagination.last_page"
    />
  </v-container>
</template>

<script>
  import * as mixins from '@/mixins/'
  import pagination from '@/components/pagination'
  import copy from 'copy-to-clipboard';

  export default {
    name: 'ProjectsListPage',
    mixins: [mixins.list, mixins.filter, mixins.sort, mixins.preloader, mixins.removable],
    data() {
      return {
        api: this.$api.projects,
        filter: {
          search: null,
        },
        sort: { order: 'id', direction: 'desc' },
        list: {
          pagination: {
            rowsPerPage:  this.$route.query.limit ? this.$route.query.limit  : 50,
            page: this.$route.query.page ? this.$route.query.page : 1,
          }
        },
      }
    },
    methods: {
      changePage(page) {
        const redirect = { name: this.$route.name, query: {page: page, limit: this.list.pagination.rowsPerPage} }
        this.list.pagination.page = page
        this.$router.push(redirect)
        this.$store.commit('setProjects', redirect)
      },
      copyText(item) {
        try {
          copy(item.name);
          this.$notify({
            group: 'success',
            type: 'success',
            text: 'Copied to clipboard'
          })
        } catch(e) {
          throw e
        }
      }
    },
    components: {
      'sl-pagination': pagination
    }
  }
</script>
